import { dedupeBy } from "src/utils";

export const dedupeById = <T extends { id: string | number }>(items: T[]) => dedupeBy(items, "id");
